<template>
  <div class="course-details">
    <section class="course-details__container">
      <video
        class="course-details__video"
        x-webkit-airplay="allow"
        x5-playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="false"
        x5-video-orientation="landscape"
        webkit-playsinline="true"
        playsinline="true"
        ref="video"
        id="video"
        preload="metadata"
        :src="currentVideoUrl"
        :controls="!isShowPoster"
        controlslist="nodownload"
        @timeupdate="updateLastPlayTime"
      >
        <source id="source" :src="currentVideoUrl" type="video/mp4" />
        <p>设备不支持</p>
      </video>
      <!-- 蒙层：游客模式：播放限制 -->
      <!-- 试看 -->
      <div v-if="videoMode === 0" >
        <div
          v-if="videoPause"
          class="course-details__pause">
          <span class="mb-48">试看已结束，登录观看完整视频</span>
          <button @click="login">立即登录</button>
        </div>
        <div v-else>
          <div
            v-if="isShowPoster"
            class="course-details__poster"
            v-control-logger.click="{ route: $route, alias: '播放' }"
            @click="playVideo"
            :style="{
              backgroundImage: `url(${imgUtils.webpFormat(currentCoverUrl, true)})`,
              backgroundSize: '100% 100%' }"
          >
            <svg-icon icon-class="pause"></svg-icon>
          </div>
        </div>
      </div>
      <div v-else-if="videoMode === 1">
        <div
          v-if="isShowPoster"
          class="course-details__poster"
          v-control-logger.click="{ route: $route, alias: '播放' }"
          @click="playVideo"
          :style="{
            backgroundImage: `url(${imgUtils.webpFormat(currentCoverUrl, true)})`,
            backgroundSize: '100% 100%' }"
        >
          <svg-icon icon-class="pause"></svg-icon>
        </div>
      </div>
      <div v-if="videoMode === 2" >
        <div
          v-if="isShowPoster"
          class="course-details__poster"
          :style="{
            backgroundImage: `url(${imgUtils.webpFormat(currentCoverUrl, true)})`,
            backgroundSize: '100% 100%' }"
        >
          <div class="course-details__pause">
            购买该课程，观看完整视频
          </div>
        </div>
      </div>
      <!-- 蒙层：收藏和返回 -->
      <div class="course-details__nav">
        <svg-icon
          v-if="details.favorited"
          class="course-details__svg--white course-details__blue"
          icon-class="course-collected" @click="handleCollect">
        </svg-icon>
        <svg-icon v-else
          class="course-details__svg--white" icon-class="course-collect" @click="handleCollect">
        </svg-icon>
      </div>
    </section>
    <div class="course-details__content" @click="onTabClickForSensors">
      <van-tabs
        v-model="tabIndex"
        color="#178fff"
        swipeable
        animated
        @click="tabsClick"
      >
        <van-tab
          title="课程目录"
          class="course-details__dir"
          :class="{'course-details__need-pay': details.costType && details.costType !== 1}"
          >
          <template v-if="details.videoCount && details.videoCount !== 0">
            <div
              v-control-logger.click="{ route: $route, alias: '视频' }"
              v-for="(item, index) in details.videos"
              :key="item.videoId"
              class="course-details__dir-item"
              @click="changeVideo(item, index)"
            >
              <div class="course-details__row mb-16">
                <span v-if="currentVideoId !== item.videoId"
                  class="course-details__label--grey mr-24">
                  {{ index + 1 }}
                </span>
                <div v-else-if="showAudio" class="course-details__svg--audio"></div>
                <img v-else class="course-details__img--audio"
                  src="~@/assets/images/audio_stop.png"/>
                <span
                  :style="{ color: currentVideoId === item.videoId ? '#178fff' : '' }"
                  class="course-details__label">
                  {{ item.videoName }}
                </span>
                <template v-if="!details.purchased">
                  <div v-if="item.isPreView" class="course-details__tag">
                    <span>试看</span>
                  </div>
                  <svg-icon
                    v-else-if="details.costType && details.costType !== 1"
                    class="course-details__svg--lock"
                    icon-class="lock"></svg-icon>
                </template>
              </div>
              <div class="course-details__label--desc ml-40">
                <span class="mr-32">{{ item.realClickCount | numberFormat }}次播放</span>
                <span>{{ item.videoHours }}</span>
              </div>
            </div>
            <div class="course-details__nomore course-details__label--desc">没有更多了</div>
          </template>
         <van-empty
            v-else
            description="暂无课程"
            :image="emptyCommentImg">
          </van-empty>
        </van-tab>
        <van-tab
          title="课程简介"
          :class="{'course-details__need-pay': details.costType && details.costType !== 1}">
          <RichText class="course-details__rich-text" :value="details.courseIntro" />
        </van-tab>
        <van-tab
          title="图文教程"
          v-if="showGraphicTutorialTab"
          :class="{'course-details__need-pay': details.costType && details.costType !== 1}"
          id="graphicTutorialIntro">
          <RichText
            v-if="graphicTutorialIntro"
            class="course-details__rich-text"
            :value="graphicTutorialIntro"/>
          <van-empty
            v-else
            class="course-details__empty"
            description="暂无图文教程"
            :image="emptyCommentImg">
          </van-empty>
        </van-tab>
      </van-tabs>
    </div>
    <footer v-if="details.costType && details.costType !== 1 && details.purchased !== 1"
      class="course-details__footer course-details__addBottom">
      <div class="course-details__wrapper" v-if="limitTimeBuy">
        <span class="course-details__label course-details__orange mr-32">限时优惠</span>
        <van-count-down :time="countdown" format="HH:mm:ss" @finish="handleFinish">
          <template #default="timeData">
            <span  class="course-details__label course-details__label--sm mr-24">
              剩余<span v-if="timeData.days > 0">{{timeData.days}}天</span>
            </span>
            <span class="course-details__time-block">{{ timeData.hours | fillZero}}</span>
            <span class="course-details__time-colon">:</span>
            <span class="course-details__time-block">{{ timeData.minutes | fillZero}}</span>
            <span class="course-details__time-colon">:</span>
            <span class="course-details__time-block">{{ timeData.seconds | fillZero}}</span>
          </template>
        </van-count-down>
      </div>
      <div class="course-details__buy">
        <div v-if="limitTimeBuy">
          <span class="course-details__price course-details__orange">
            {{details.discountPrice| priceFormat}}
          </span>
          <span
            v-if="details.discountPrice <= details.costPrice"
            class="course-details__label--grey" >
            <del>{{details.costPrice | priceFormat}}</del>
          </span>
        </div>
        <div v-else-if="details.costType === 2 || details.costType === 4">
          <span class="course-details__price course-details__orange">
            {{details.costPrice | priceFormat}}
          </span>
        </div>
        <button @click="buyNow">立即购买</button>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  fetchPaidCoursePlayRecord,
  fetchCourseDirDetails,
  cancelFavoriteCourse,
  favoriteCourse,
} from '@/services/modules/course';
import {
  Tabs, Tab, Toast, Empty, CountDown,
} from 'vant';
import dayjs from 'dayjs';
import '@/styles/theme/resetVantUI.less';
import RichText from '@/components/RichText.vue';
import imgUtils from '@/utils/helpers/img';
import { emptyCommentImg, OWNER_ROLE_ID } from '@/utils/consts/default';
import { setPageTitle } from '@/utils/helpers';
import { checkLogin, isLogin } from '@/utils/helpers/login-role';
import authStore from '@/store/auth';
import courseSensorsData from '@/core/mixins/courseSensorsData';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CourseFreeDetails',
  mixins: [courseSensorsData],
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [CountDown.name]: CountDown,
    RichText,
  },
  data() {
    return {
      // IMG
      emptyCommentImg,

      imgUtils,

      courseId: '',
      isShowPoster: true,
      tabIndex: 0,

      currentVideoId: '',
      currentVideoName: '',
      currentVideoUrl: '',
      currentCoverUrl: '',
      currentVideo: {},
      details: {
        courseId: '',
        courseIntro: '',
        videos: [],
      },
      limitTimeBuy: false, // 是否限时优惠
      videoPause: false, // 试看结束，要登录或者购买
      videoMode: 0, // 0: 试看, 1: 可看, 2： 不可看（需购买或者登录）
      showAudio: false,

      // 图文教程
      videoIndex: 0,
      courseType: '课程',
      vid: '',
      firstIndex: 0,
      newVideos: [],
    };
  },
  computed: {
    ...mapState('user', { roleId: (state) => state.roleId }),
    commentPayload() {
      return {
        modleId: 5,
        topicId: this.currentVideoId,
        videoType: 1,
        courseId: this.courseId,
      };
    },
    graphicTutorialIntro() {
      const { videos } = this.details;
      if (this.showGraphicTutorialTab && videos && videos[this.videoIndex]) {
        return this.details.videos[this.videoIndex].videoIntro;
      }
      return '';
    },
    showGraphicTutorialTab() {
      return this.details.showVideoIntro;
    },
    /* 限时优惠 */
    countdown() {
      if (this.limitTimeBuy) {
        return dayjs(this.details.discountEndTime) - dayjs();
      }
      return 0;
    },
  },
  watch: {
    tabIndex() {
      // 切换tab滚回顶部
      const content = document.getElementsByClassName('van-tabs__content')[0];
      if (content) {
        content.scrollTo(0, 0);
      }
    },
    currentVideo(newVal) {
      const { isPreView = 0 } = newVal;
      const { costType, purchased } = this.details;
      // costType:课程费用类型（1.免费 2.付费 4.限时优费）
      // 播放状态：videoMode 0: 试看, 1: 可看, 2： 不可看（需购买或者登录）
      if (costType === 1 || (costType !== 1 && isPreView)) {
        // 1.免费或者可试看的付费视频--登录可看，未登录试看
        this.videoMode = isLogin ? 1 : 0;
      } else if (costType !== 1 && !isPreView) {
        // 2.不可试看的付费视频--已购买的可看，未购买的不可看
        this.videoMode = isLogin && purchased ? 1 : 2;
      }
      this.$refs.video.addEventListener('pause', () => {
        this.showAudio = false;
      });
      this.$refs.video.addEventListener('play', () => {
        this.showAudio = true;
      });
    },
  },
  mounted() {
    this.courseId = this.$route.params.id;
    this.vid = this.$route.query.vid;
    fetchCourseDirDetails({ courseId: this.courseId }).then((res) => {
      if (res) {
        setPageTitle(res.courseName);
        this.details = res;
        this.limitTimeBuy = this.getFlashSaleTime();
        if (res.videos) {
          if (this.vid) {
            this.firstIndex = res.videos.findIndex((item) => item.videoId === this.vid);
            this.newVideos = res.videos.filter((item) => item.videoId === this.vid);
            this.changeVideo(...this.newVideos, this.firstIndex);
            this.currentVideoUrl = this.newVideos[0].videoUrl || '';
            this.currentCoverUrl = this.newVideos[0].videoImage || '';
            this.currentVideoId = this.newVideos[0].videoId || '';
            this.currentVideoName = this.newVideos[0].videoName || '';
          } else {
            this.currentVideoUrl = res.videos[0].videoUrl || '';
            this.currentCoverUrl = res.videos[0].videoImage || '';
            this.currentVideoId = res.videos[0].videoId || '';
            this.currentVideoName = res.videos[0].videoName || '';
          }
          [this.currentVideo] = res.videos;
        }
        this.setPageViewSensorsData(this.details);
      }
    });
  },
  destroyed() {
    const dom = document.getElementById('video');
    if (dom) {
      dom.pause();
      dom.muted = false;
    }
  },
  methods: {
    ...mapActions('user', ['getRoleId']),
    onTabClickForSensors(event) {
      this.$sensors.quick('trackHeatMap', event.target);
    },
    async buyNow() {
      if (checkLogin()) {
        // 业主拦截购买
        if (this.roleId !== OWNER_ROLE_ID && this.roleId) {
          this.$router.push({
            name: 'Course.Order',
            params: { id: this.courseId },
          });
        } else {
          const currentRoleId = await this.getRoleId();
          if (currentRoleId === OWNER_ROLE_ID) {
            Toast({ message: '抱歉，当前账号暂不支持购买', position: 'bottom' });
          } else {
            this.$router.push({
              name: 'Course.Order',
              params: { id: this.courseId },
            });
          }
        }
      }
    },
    // 获取限时播放时间
    getLimitPlayTime(currentTime) {
      const { duration = 0 } = this.$refs.video;
      if (duration <= 30) {
        return false;
      } if (duration > 30 && duration <= 60) {
        return currentTime > 10;
      } if (duration > 60 && duration <= 60 * 5) {
        return currentTime > 30;
      }
      return currentTime > 60;
    },
    // 获取是否为限时优惠时间
    getFlashSaleTime() {
      return this.details.costType === 4
      && this.discountTime(this.details.discountStartTime, this.details.discountEndTime);
    },
    /**
     * 播放或暂停视频
     * @param {String} video 视频数据
     * @param {Number} videoIndex 视频所属下标
     */
    changeVideo(video, videoIndex) {
      if (this.videoIndex === videoIndex) return;
      this.setVideoChangeSensorsData();
      this.currentVideo = video;
      this.currentVideoUrl = video.videoUrl;
      this.currentCoverUrl = video.videoImage;
      this.currentVideoId = video.videoId;
      this.currentVideoName = video.videoName;
      this.videoPause = false;
      this.$nextTick(() => {
        // 已购买或免费视频，点击目录切换需要自动播放视频
        if (this.videoMode !== 2) {
          this.$refs.video.setAttribute('autoplay', 'autoplay');
          this.playVideo();
        } else {
          // 付费课程不可播放
          this.$refs.video.pause();
          this.$refs.video.removeAttribute('autoplay');
          this.isShowPoster = true;
          this.showAudio = false;
        }
      });

      // 切换图文教程的数据
      this.videoIndex = videoIndex;
      // 图文教程内容滚动到顶部
      const graphicTutorialIntro = document.getElementById('graphicTutorialIntro');
      if (graphicTutorialIntro) {
        graphicTutorialIntro.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    },
    /** 倒计时结束 */
    handleFinish() {
      this.limitTimeBuy = this.getFlashSaleTime();
    },
    handleCollect() {
      if (checkLogin()) {
        if (this.details.favorited) {
          cancelFavoriteCourse({ courseId: this.courseId }).then(() => {
            this.details.favorited = 0;
          });
        } else {
          favoriteCourse({ courseId: this.courseId }).then(() => {
            this.details.favorited = 1;
          });
        }
      }
    },
    login() {
      checkLogin();
    },
    playVideo() {
      // if (this.$videoMode !== 2) {
      //   this.setVideoChangeSensorsData();
      // }
      this.isShowPoster = false;
      // 捕获播放被中断时的错误，不用处理，不影响
      const playPromise = this.$refs.video.play();
      // 1、未登录或未付费下，监听播放进度，超过试看时间则暂停播放
      if (this.videoMode === 0) {
        this.$refs.video.addEventListener('timeupdate', () => {
          const { currentTime = 0 } = this.$refs.video;
          if (this.getLimitPlayTime(currentTime)) {
            this.videoPause = true;
            this.$refs.video.pause();
          }
        });
      }
      if (playPromise !== undefined) {
        playPromise.then(() => {}).catch(() => {});
      }
      // 点击播放时，发送播放记录请求
      fetchPaidCoursePlayRecord({ courseId: this.courseId, videoId: this.currentVideoId });
    },
    /**
     * Tabs点击事件
     */
    tabsClick(name, title) {
      const loggerInfo = authStore.state.loggerInfoFromSwjApp;
      this.$logger.click({
        actionType: 'click_APP_native',
        eventLabel: JSON.stringify({
          pageTitle: this.$route.meta.title,
          alias: title,
        }),
        ...loggerInfo,
      });
    },
    discountTime(startTime, endTime) {
      return dayjs().isAfter(dayjs(startTime)) && dayjs().isBefore(dayjs(endTime));
    },
  },
};
</script>

<style lang="less" scoped>
.course-details {
  /deep/ .van-tab__pane-wrapper {
    max-height: calc(100vh - 624px);
    overflow-y: scroll;
  }
  /deep/.van-tabs__line {
    max-width: 56px;
  }
  /deep/.van-tab__pane {
    min-height: 240px;
  }
  /deep/.van-tab--active {
    font-weight: bold;
  }
  /deep/.van-tab {
    .hairline-wrap();
  }
  &__container {
    position: relative;
    width: 100vw;
    height: 422px;
  }
  &__video {
    width: 100vw;
    height: 422px;
  }
  video::-webkit-media-controls-mute-button {
    display: none !important;
  }
  &__nav {
    position: absolute;
    top: 12px;
    right: 28px;
    z-index: 222;
    .flex-center();
    width: 64px;
    height: 64px;
    box-sizing: border-box;
    background: rgba(0,0,0,0.20);
    border-radius: 4px;
  }
  &__pause {
    position: absolute;
    top: 0;
    left: 0;
    .flex-center();
    flex-direction: column;
    width: 100vw;
    height: 422px;
    background-color: rgba(0, 0, 0, 0.5);
    .font-size-28();
    color: @white;
    button {
      .button(200px, 72px, 36px);
      background-image: linear-gradient(270deg, #33C2FF 2%, #178FFF 95%);
    }
  }
  &__poster {
    position: absolute;
    z-index: 111;
    width: 100vw;
    height: 422px;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    svg {
      fill: #fff;
      font-size: 120px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-mask {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  &__content {
    width: 100vw;
  }
  &__dir {
    width: 100vw;
    &-item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 152px;
      box-sizing: border-box;
      padding: 0 32px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.03);
      cursor: pointer;
    }
  }
  &__need-pay {
    padding-bottom: 166px;
  }
  &__row {
    .flex-center-vertical();
  }

  &__tag {
    .flex-center();
    width: 64px;
    height: 32px;
    box-sizing: border-box;
    margin-left: auto;
    font-size: 20px;
    color: @primary-color;
    border: 1px solid @primary-color;
    border-radius: 4px;
  }

  &__nomore {
    padding: 32px;
    text-align: center;
  }

  // 富文本边距
  &__rich-text {
    margin: 32px;
    margin-top: 40px;
  }

  &__empty {
    height: calc(100vh - 510px);
  }
  &__svg {
    position: absolute;
    right: 32px;
    font-size: 56px;
    color: rgba(0, 0, 0, 0.1);
    &--audio {
      display: inline-block;
      width: 28px;
      height: 28px;
      margin-right: 12px;
      background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg' fill='%23178fff'%3E%3Cg transform='matrix(1 0 0 -1 0 60)'%3E%3Crect width='12' height='20' rx='5'%3E%3Canimate attributeName='height' begin='0s' dur='6.3s' values='30;45;57;42;27;16;19;42;35;31;38;39;43;56;48;43;50' calcMode='linear' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='24' width='12' height='60' rx='5'%3E%3Canimate attributeName='height' begin='0s' dur='4s' values='50;34;48;23;56;52;48;40;34;21;50' calcMode='linear' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='48' width='12' height='40' rx='5'%3E%3Canimate attributeName='height' begin='0s' dur='2.4s' values='30;45;55;60;56;60;45;42;34;52;33;30' calcMode='linear' repeatCount='indefinite'/%3E%3C/rect%3E%3C/g%3E%3C/svg%3E")
        no-repeat center;
      animation-play-state: paused;
      background-size: 100%;
    }
  }

  &__img--audio {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 12px;
  }

  &__svg--lock {
    width: 32px;
    height: 32px;
    margin-left: auto;
    color: @secondary-text-color;
  }

  &__svg--white {
    width: 56px;
    height: 56px;
    color: @white
  }

  // 文字样式
  &__label {
    .font-size-28();
    color: @title-text-color;
    &--sm {
      .font-size-24();
    }
  }
  &__label--grey {
    .font-size-28();
    color: @secondary-text-color;
  }
  &__label--desc {
    .font-size-24();
    color: @secondary-text-color;
  }
  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: @white;
  }
  &__buy {
    .flex-center-vertical();
    height: 104px;
    justify-content: space-between;
    padding: 0 32px;
    border-top: 1px solid #eee;
    background-color: @white;
    button {
      .button(240px, 64px);
    }
  }
  &__wrapper {
    position: absolute;
    top: -60px;
    .flex-center-vertical();
    width: 520px;
    height: 60px;
    padding: 0 32px;
    box-sizing: border-box;
    border-radius: 0 24px 0 0;
    opacity: 0.9;
    background: #FFF2E8;
  }
  &__time-block {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #FF7A45;
    border-radius: 4px;
    .font-size-24();
    color: @white;
  }
  &__time-colon {
    display: inline-flex;
    justify-content: center;
    width: 24px;
    .font-size-24();
    color: @primary-text-color;
  }
  &__price {
    .font-size-48();
    font-family: @custom-font-family;
  }
  &__orange {
    color: #FA541C;
  }
  &__blue {
    color: @primary-color;
  }
  /* 判断iPhone 将 footer 的 padding-bottom 填充到最底部 */
  @supports (bottom: env(safe-area-inset-bottom)){
    .course-details__addBottom {
      padding-bottom: constant(safe-area-inset-bottom, 20px);
      padding-bottom: env(safe-area-inset-bottom, 20px);
      padding-bottom: var(safe-area-inset-bottom, 20px);
    }
  }
}
</style>
